import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { makeApiRequest } from '../axiosService/apiCall';
import { ToastContainer, toast } from "react-toastify";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import { ImBubbles3 } from "react-icons/im";



function Usertransferwallet() {
    const [requestHis, setRequestHis] = useState([]);
    // console.log("requestHis---", requestHis);
    const [data, setData] = useState([]);
    const [loadingId, setLoadingId] = useState({ id: null, action: null });
    const [isLoading, setIsLoading] = useState(false);

    const [filterStatus, setFilterStatus] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [copiedValue, setCopiedValue] = useState('');
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [approvalStatus, setApprovalStatus] = useState(null);
    const [reason, setReason] = useState("")

    const handleOpenModal = (data) => {
        setReason(data);
    };

    useEffect(() => {
        fetchRequestDetails();
    }, []);

    const approvalData = async (id, status, amount) => {
        setLoadingId({ id, action: status }); // Track which button is processing

        try {
            const swalResult = await Swal.fire({
                title: status === "approve"
                    ? "Are you sure you want to Approve the userwallettransfer request?"
                    : "Are you sure you want to userwallettransfer request?",
                icon: "question",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                showCancelButton: true,
                showCloseButton: true,
                ...(status === "reject" && {
                    html: '<label for="swal-input" style="margin-top: 10px;">Enter reason for rejection</label>' +
                        '<input id="swal-input" class="swal2-input input-reason" placeholder="Reason" maxlength="255">',
                    preConfirm: () => {
                        const rejectionReason = document.getElementById('swal-input').value.trim();
                        if (!rejectionReason) {
                            Swal.showValidationMessage('Please provide a reason for rejection');
                            return false;
                        }
                        return rejectionReason;
                    },
                })
            });

            if (swalResult.isConfirmed) {
                const payload = {
                    type: status,
                    id,
                    amount,
                    ...(status === "reject" && { reason: swalResult.value }),
                };

                const params = {
                    url: "adminusertusertransferaction",
                    method: "POST",
                    data: payload,
                };

                const response = await makeApiRequest(params);

                if (response.status) {
                    setFilteredData(prevData =>
                        prevData.map(row =>
                            row._id === id
                                ? { ...row, status: status === "approve" ? 2 : 3 }
                                : row
                        )
                    );

                    toast.success(status === "approve" ? "Approved Successfully" : "Rejected Successfully");

                    fetchRequestDetails();
                } else {
                    toast.warning(response.message);
                }
                // if (response.status) {
                //     toast.success(response.message);
                //     setTimeout(() => {
                //         fetchRequestDetails();
                //     }, 2000);
                // } else {
                //     toast.warning(response.message);
                // }
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoadingId({ id: null, action: null }); // Reset loading for that row
        }
    };



    const fetchRequestDetails = async () => {
        try {
            let params = {
                url: `getusertusertransferhistory`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);
            // console.log("getusertusertransferhistory--", response);
            if (response.status === true) {
                setRequestHis(response.data);
                setFilteredData(response.data);

            } else {
                setRequestHis([]);
                setFilteredData([]);

            }
        } catch (error) {
            console.log(error);
        }
    }


    useEffect(() => {
        let filtered = [...requestHis];

        if (filterStatus !== null) {
            filtered = filtered.filter(item => item.status === filterStatus);
        }

        if (searchQuery.trim() !== "") {
            const searchQueryLower = searchQuery.toLowerCase();

            filtered = filtered.filter(item => {
                const requestDate = new Date(item.RequestDate).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric"
                });

                const approvalDate = item.ApprovalorrejectDate
                    ? new Date(item.ApprovalorrejectDate).toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric"
                    })
                    : "";

                return (
                    item.fromEmail.toLowerCase().includes(searchQueryLower) ||
                    item.toEmail.toLowerCase().includes(searchQueryLower) ||
                    requestDate.includes(searchQueryLower) ||  // Match exact "DD/MM/YYYY"
                    approvalDate.includes(searchQueryLower)    // Match exact "DD/MM/YYYY"
                );
            });
        }

        setFilteredData(filtered);
    }, [filterStatus, searchQuery, requestHis]);

    const columnsone = [
        {
            name: 'S.No', width: '80px', selector: (row, index) => index + 1 + (currentPage - 1) * rowsPerPage
            , sortable: true
        },
        {
            name: 'Date',
            selector: row => new Date(row.RequestDate).toLocaleString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
                timeZone: "Asia/Kolkata"
            }),
            sortable: true,
            width: "200px"

        },
        {
            name: 'Approval or Reject Date',
            selector: row => row.ApprovalorrejectDate
                ? new Date(row.ApprovalorrejectDate).toLocaleString("en-IN", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: true,
                    timeZone: "Asia/Kolkata"
                })
                : "-",
            sortable: true,
            width: "250px"
        },
        {
            name: 'From Email',
            selector: row => row.fromEmail,
            sortable: true,
            width: "350px"
        },
        {
            name: 'To Email',
            selector: row => row.toEmail,
            sortable: true,
            width: "350px"
        },
        {
            name: 'Total Amount',
            width: "200px",
            selector: row => row.
                amount,
            sortable: true,
        },
        {
            name: 'Reject Reason',
            selector: row => <div className='d-flex'>
                {(row.Rejectedreason || "").length > 20
                    ? row.Rejectedreason.substring(0, 10) + "..."
                    : row.Rejectedreason || "N/A"
                }
                {(row.Rejectedreason || "").length
                    ? <p type="button" className='ms-2' data-bs-toggle="modal" data-bs-target="#rejectReasonModal"
                        onClick={() => handleOpenModal(row.Rejectedreason)}>
                        <ImBubbles3 />
                    </p>
                    : ""
                }
                <div className="modal fade" id="rejectReasonModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="rejectReasonLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title fs-5" id="rejectReasonLabel">Reject Reason</h1>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body" style={{ wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "normal" }}>
                                {reason || "No reason provided"}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            sortable: true,
            width: "200px"
        },
        {
            name: 'Action',
            cell: (row) => (
                <div className='d-flex align-items-center gap-3'>
                    {loadingId.id === row._id ? (
                        <span className="loader">Processing...</span>
                    ) : (
                        <>
                            {row.status === 1 && (
                                <>
                                    <button
                                        className='Aproved'
                                        disabled={loadingId.id === row._id || row.status !== 1}
                                        onClick={() => approvalData(row._id, 'approve', row.reStakeAmount)}
                                    >
                                        {loadingId.id === row._id && loadingId.action === 'approve' ? "Processing..." : "Approve"}
                                    </button>
                                    <button
                                        className='reject'
                                        disabled={loadingId.id === row._id || row.status !== 1}
                                        onClick={() => approvalData(row._id, 'reject', row.reStakeAmount)}
                                    >
                                        {loadingId.id === row._id && loadingId.action === 'reject' ? "Processing..." : "Reject"}
                                    </button>
                                </>
                            )}
                            {row.status === 2 && <button className='Aproved' disabled>Approved</button>}
                            {row.status === 3 && <button className='reject' disabled>Rejected</button>}
                        </>
                    )}
                </div>
            ),
            width: "250px"
        },
    ];

    return (
        <div className='App'>
            <ToastContainer />

            <div className='container'>
                <div className='custom-saled-order text-dark ms-3'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className="py-3 d-flex justify-content-between">
                                <h3 className="component-user">User To User WalletTransfer Request</h3>
                            </div>

                            <div className='row'>
                                <div className='col-lg-6'>
                                    <input
                                        className="form-control form-search"
                                        type="text"
                                        placeholder="Search by Email or Date"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}

                                    />
                                </div>
                                <div className='col-lg-3'>
                                    <div className="mb-3">
                                        <select
                                            className="form-select form-search"
                                            value={filterStatus ?? ''}
                                            onChange={(e) => setFilterStatus(e.target.value ? Number(e.target.value) : null)}
                                        >
                                            <option value="">All</option>
                                            <option value="1">Pending</option>
                                            <option value="2">Approved</option>
                                            <option value="3">Rejected</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-12'>
                                    <div className='custom-datascroll'>
                                        <DataTable
                                            columns={columnsone}
                                            data={filteredData}
                                            pagination
                                            highlightOnHover
                                            dense
                                            // noDataComponent="No records found"
                                            persistTableHead={true}
                                            paginationPerPage={rowsPerPage}
                                            paginationRowsPerPageOptions={[10, 20, 30, 50]}
                                            onChangePage={(page) => setCurrentPage(page)}
                                            onChangeRowsPerPage={(newRowsPerPage, page) => {
                                                setRowsPerPage(newRowsPerPage);
                                                setCurrentPage(page);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Usertransferwallet